<template>
  <view>
    <!-- v3.15导航栏样式统一 -->
    <!-- #ifdef  MP-WEIXIN || MP-ALIPAY -->
    <view
      class="custom-nav"
      :style="{ height: navigationBarHeight, background: backgroundColor }"
      v-show="showNav"
    >
      <view class="home" v-if="type === 'home'" :style="{ height: navigationBarHeight }">
        <!-- 搜索 -->
        <view :style="{ height: statusBarHeight }"></view>
        <homeNav :isSearch="isSearch" :height="capsuleHeight + 'px'" />
      </view>
      <view v-if="!type">
        <view :style="{ height: statusBarHeight }"></view>
        <view class="title-container">
          <view
            class="capsule"
            v-if="(back || home) && showLeft"
            :style="'top:' + capsuleTop + 'px; height:' + capsuleHeight + 'px;'"
          >
            <view class="capsule-child" @tap="navBack" v-if="back">
              <view
                class="iconfont icon-zuo1 icon-size"
                :style="'padding:14px;color: ' + iconColor + ';'"
              ></view>
            </view>
            <view class="line" v-if="home && back && !hiddenHome"></view>
            <view class="capsule-child" @tap="toIndex" v-if="home && !hiddenHome">
              <view
                class="iconfont icon-shouye icon-size"
                :style="'padding:14px;color: ' + iconColor + ';'"
              ></view>
            </view>
          </view>
          <view
            class="title"
            :style="{
              color: titleColor,
              backgroundColor: titleBg,
              borderRadius: titleBorderRadius,
            }"
            >{{ title }}</view
          >
        </view>
      </view>
    </view>
    <view
      :style="{ height: navigationBarHeight, background: 'rgba0,0,0,0' }"
      v-show="showNav"
    ></view>
    <!-- #endif -->
    <!-- 原支付宝导航栏样式 -->
    <!-- #ifdef MP-ALIPAY -->
    <!-- <view class="custom-nav" :style="{ height: navigationBarHeight, background: backgroundColor }">
    <view v-show="navBg" class="custom-nav" :style="{ height: navigationBarHeight}">
      <image
        class="x-img"
        :src="navBg"
        :data-item="item"
        mode="widthFix"
        style="width: 100%;"
      ></image>
    </view> -->
    <!-- #endif -->
  </view>
</template>

<script>
import jump from '@/utils/jump';
import homeNav from './home-nav';
export default {
  props: {
    title: String,
    navBg: String,
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
    titleColor: {
      default: 'black',
      type: String,
    },
    iconColor: String,
    titleBg: {
      type: String,
      default: 'transparent',
    },
    titleBorderRadius: {
      type: Number,
      default: 0,
    },
    hiddenHome: {
      type: Boolean,
      default: false,
    },
    backCompletion: Boolean,
    type: {
      default: '',
      type: String,
    },
    scrollTop: {
      type: Number,
      default: 0,
    },
  },
  options: {
    addGlobalClass: true,
  },
  computed: {
    isSearch() {
      return this.scrollTop >= 37;
    },
    showNav() {
      let isShow = false;
      // #ifdef MP-ALIPAY
      isShow = this.navBg;
      // #endif
      // #ifdef MP-WEIXIN
      isShow = true;
      // #endif
      return isShow;
    },
  },
  data() {
    return {
      back: true,
      home: true,
      showLeft: true,
      statusBarHeight: '',
      navigationBarHeight: '',
      capsuleTop: '',
      capsuleHeight: '',
      menuButtonObject: {
        width: 0,
        left: 0,
      },
    };
  },
  beforeMount() {
    const pages = getCurrentPages();
    if (pages.length > 1) {
      this.back = true;
    } else {
      if (
        pages[0].route.startsWith('pages/index') ||
        pages[0].route.startsWith('pages/category') ||
        pages[0].route.startsWith('pages/mine') ||
        pages[0].route.startsWith('pages/minipage') ||
        pages[0].route.startsWith('pages/cart') ||
        pages[0].route.startsWith('pages/member-home')
      ) {
        this.showLeft = false;
      } else {
        this.back = false;
        this.showLeft = true;
      }
    }
    this.setNavigationBarStyle();
  },
  mounted() {
    this.$emit('mounted', { navigationBarHeight: this.navigationBarHeight });
  },
  methods: {
    setNavigationBarStyle() {
      uni.getSystemInfo({
        success: res => {
          // #ifdef MP-WEIXIN || MP-ALIPAY
          const statusBarHeight = res.statusBarHeight;
          const menuButtonObject = uni.getStorageSync('menuButtonObject') || uni.getMenuButtonBoundingClientRect() || {
            bottom: 82,
            height: 32,
            left: 278,
            right: 365,
            top: 50,
            width: 87,
          };
          this.menuButtonObject = menuButtonObject;
          if (menuButtonObject.height) {
            uni.setStorageSync('menuButtonObject', menuButtonObject);
          }
          const navHeight =
            statusBarHeight +
            menuButtonObject.height +
            (menuButtonObject.top - statusBarHeight) * 2; // 导航高度
          this.statusBarHeight = statusBarHeight + 'px';
          this.navigationBarHeight = navHeight + 'px';
          this.capsuleTop = menuButtonObject.top - statusBarHeight;
          this.capsuleHeight = menuButtonObject.height;
          // #endif

          // #ifdef MP-ALIPAY
          // this.navigationBarHeight = (res.statusBarHeight + res.titleBarHeight) + 'px';
          // #endif
        },
      });
    },
    getMenuButtonObject() {
      let menuButtonObject = uni.getMenuButtonBoundingClientRect();
      if (menuButtonObject && menuButtonObject.height) {
        uni.setStorageSync('menuButtonObject', menuButtonObject);
      } else {
        const localMenuButtonObject = uni.getStorageSync('menuButtonObject');
        if (localMenuButtonObject && localMenuButtonObject.height) {
          menuButtonObject = localMenuButtonObject;
        } else {
          menuButtonObject = {
            bottom: 82,
            height: 32,
            left: 278,
            right: 365,
            top: 50,
            width: 87,
          };
        }
      }
      return menuButtonObject;
    },
    onClick() {
      if (this.properties.item) {
        jump.toLocation(this.properties.item);
      }
    },
    // 回退
    navBack: function() {
      if (this.backCompletion) {
        this.$emit('tapBack');
        return;
      }
      uni.navigateBack({
        delta: 1,
      });
    },
    // 回主页
    toIndex: function() {
      uni.switchTab({
        url: '/pages/index',
      });
    },
  },
  // #ifdef MP-ALIPAY
  watch: {
    title: {
      handler(val) {
        if (val && typeof val === 'string') {
          uni.setNavigationBarTitle({
            title: val,
          });
        }
      },
    },
  },
  // #endif
  components: {
    homeNav,
  },
};
</script>
<style scoped lang="scss" scoped>
@import '../../styles/var.scss';
@import '../../styles/func.scss';
.custom-nav {
  width: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  overflow: hidden;
  .custom-nav-search {
    display: flex;
    align-items: center;
  }
}
.navigation-item {
  width: 24px;
  height: 24px;
}
.title-container {
  height: 44px;
  position: relative;
  .capsule {
    position: absolute;
    left: 10px;
    border: 0.5px solid #ededed;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: row;
    .line {
      width: 1px;
      height: 70%;
      background: #ededed;
    }
    .icon-size {
      font-size: 16px;
    }
  }
  .capsule-child {
    display: flex;
  }
  .title {
    color: black;
    position: absolute;
    top: 8px;
    left: 104px;
    right: 104px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
